<template>
    <div class="login">
        <div>
            <codelogin v-if="showlogin" ref="stop_check"></codelogin>
            <paylogin v-if="logintype && logintype.types == 2 && !showlogin"></paylogin>
            <pwdlogin v-if="logintype && logintype.types == 3 && !showlogin"></pwdlogin>
            <accountlogin v-if="logintype && logintype.types == 4 && !showlogin" :logintype="logintype"></accountlogin>
            <infologin v-if="logintype && logintype.types == 5 && !showlogin" :infolist="logintype.applyJson">
            </infologin>
            <invitelogin v-if="logintype && logintype.types == 6 && !showlogin"></invitelogin>
        </div>
    </div>
</template>
<script>
import codelogin from '@/components/livelogin/codelogin.vue'
import pwdlogin from '@/components/livelogin/pwdlogin.vue'
import accountlogin from "@/components/livelogin/accountlogin.vue"
import invitelogin from "@/components/livelogin/invitelogin.vue"
import paylogin from "@/components/livelogin/paylogin.vue"
import infologin from "@/components/livelogin/infologin.vue"
export default {
    name: 'livelogin',
    props: {
        logintype: Object
    },
    data() {
        return {
            showlogin: true
        }
    },
    created() {
        // if(localStorage.getItem('user_token')){
        //     this.showlogin = false
        // }

    },
    mounted() {
        if (localStorage.getItem("user_token_" + localStorage.getItem(this.$route.params.id+'c_id'))) {
            this.$liveapi.livechecktoken(localStorage.getItem("user_token_" + localStorage.getItem(this.$route.params.id+'c_id'))).then(res => {
                if (res.data.data.stats == "1") {
                    this.showlogin = false
                    this.$refs.stop_check.stop_check()
                }
            })
        }
    },
    components: {
        codelogin,
        pwdlogin,
        accountlogin,
        invitelogin,
        paylogin,
        infologin
    },
    methods: {

    },
}
</script>
<style scoped>
* {
    margin: 0;
    padding: 0;
}


.view_login {
    width: 740px;
    height: 472px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -470px;
    margin-top: -300px;
    z-index: 2;
}

.view_login>img {
    widows: 470px;
    height: 600px;
    float: left;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1500);
}

.view_login>div {
    float: right;
}

.tips {
    position: absolute;
    top: 90%;
    left: 46%;
    color: #777777;
    font-size: 14px;
}
</style>
